import styled from 'styled-components'

export const QuantityCounterStyled = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space.xsmall};

  padding: 0;
  background-color: ${({ theme }) => theme.colors.neutral};
  border-radius: ${({ theme }) => theme.typography.pxToRem(8)};

  min-width: ${({ theme }) => theme.typography.pxToRem(90)};
`
